import { isEmpty } from "lodash";
const queryString = require("query-string");

export const stringifyParams = (params: any) => {
  return !isEmpty(params) ? `?${queryString.stringify(params)}` : "";
};
